/**
 * @generated SignedSource<<0800697288d88046346de397729db8ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type LessonTypeSelect_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useGetLessonTypeOptions_session">;
  readonly " $fragmentType": "LessonTypeSelect_session";
};
export type LessonTypeSelect_session$key = {
  readonly " $data"?: LessonTypeSelect_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LessonTypeSelect_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetLessonTypeOptions_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "2d1f38d52be04d13506b0bad206c8bd5";

export default node;
